<div>
<app-home *ngIf="!hvacContractor"></app-home>
<app-hvac-home *ngIf = "hvacContractor"></app-hvac-home>
</div>
